export default __webpack_public_path__ + "static/media/curve2.3220830c.svg";